import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HttpClient } from '@angular/common/http';

import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { AppComponent } from './app.component';

import { AuthGuard } from './guard/auth.guard';
import { AuthService } from './service/auth.service';
import { WebApiService } from './service/web-api.service';
import { ErrorComponent } from './component/error/error.component';
import { MessageModalComponent } from './component/message-modal/message-modal.component';
import { WaitModalComponent } from './component/wait-modal/wait-modal.component';
import { ConfirmModalComponent } from './component/confirm-modal/confirm-modal.component';
import { DocumentModalComponent } from './component/document-modal/document-modal.component';
import { SignInComponent } from './component/sign-in/sign-in.component';
import { SignUpComponent } from './component/sign-up/sign-up.component';
import { ResetPasswordComponent } from './component/reset-password/reset-password.component';
import { ConsentComponent } from './component/consent/consent.component';
import { TermsOfServiceComponent } from './component/terms-of-service/terms-of-service.component';
import { SelectResourceComponent } from './component/select-resource/select-resource.component';
import { SelectMultiResourceComponent } from './component/select-multi-resource/select-multi-resource.component';
import { CustomViewService } from './service/custom-view.service';
import { CheckMailCompleteComponent } from './component/check-mail-complete/check-mail-complete.component';
import { ConsentOidcComponent } from './component/consent-oidc/consent-oidc.component';
import { MfaTelephoneComponent } from './component/mfa-telephone/mfa-telephone.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MfaTelephoneModalComponent } from './component/mfa-telephone-modal/mfa-telephone-modal.component';

export const AppRoutes = [
  { path: 'sign-in', component: SignInComponent, canActivate: [AuthGuard], data: { screenId: 'O01' } },
  { path: 'sign-in/portal', component: SignInComponent, canActivate: [AuthGuard], data: { screenId: 'O01', isPortal: true } },
  { path: 'sign-up', component: SignUpComponent, canActivate: [AuthGuard], data: { screenId: 'O02' } },
  { path: 'sign-up/:pageNo', component: SignUpComponent, canActivate: [AuthGuard], data: { screenId: 'O02' } },
  { path: 'reset-password', component: ResetPasswordComponent, canActivate: [AuthGuard], data: { screenId: 'O03' } },
  { path: 'reset-password/:pageNo', component: ResetPasswordComponent, canActivate: [AuthGuard], data: { screenId: 'O03' } },
  { path: 'consent', component: ConsentComponent, canActivate: [AuthGuard], data: { screenId: 'O04' } },
  { path: 'terms-of-service', component: TermsOfServiceComponent, canActivate: [AuthGuard], data: { screenId: 'O05' } },
  { path: 'select-resource', component: SelectResourceComponent, canActivate: [AuthGuard], data: { screenId: 'O06' } },
  { path: 'select-multi-resource', component: SelectMultiResourceComponent, canActivate: [AuthGuard], data: { screenId: 'O07' } },
  { path: 'consent-oidc', component: ConsentOidcComponent, canActivate: [AuthGuard], data: { screenId: 'O08' } },
  { path: 'mfa-telephone', component: MfaTelephoneComponent, canActivate: [AuthGuard], data: { screenId: 'O09' } },
  { path: 'check-mail-complete/:serviceName', component: CheckMailCompleteComponent },
  { path: 'mfa-telephone', component: MfaTelephoneComponent, canActivate: [AuthGuard], data: { screenId: 'O09' } },
  { path: 'error/:status', component: ErrorComponent },
  { path: '**', component: ErrorComponent }
];

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
    MessageModalComponent,
    WaitModalComponent,
    ConfirmModalComponent,
    DocumentModalComponent,
    SignInComponent,
    SignUpComponent,
    ResetPasswordComponent,
    ConsentComponent,
    TermsOfServiceComponent,
    SelectResourceComponent,
    SelectMultiResourceComponent,
    CheckMailCompleteComponent,
    ConsentOidcComponent,
    MfaTelephoneComponent,
    MfaTelephoneModalComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    RouterModule.forRoot(AppRoutes, { relativeLinkResolution: 'legacy' }),
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [AuthGuard, AuthService, WebApiService],
  bootstrap: [AppComponent]
})
export class AppModule { }
